module.exports = __webpack_public_path__ + "img/item6-1.88dd7a60.jpg";